import { jsx as r } from "@emotion/react/jsx-runtime";
import { DEFAULT_COLORS as n } from "./helpers.js";
import { SidebarComponent as f } from "./Sidebar.js";
import { SidebarProvider as S } from "./SidebarContext.js";
const l = ({
  children: o,
  logo: i,
  moreText: m,
  extended: e,
  setExtended: t,
  colors: p,
  routes: d
}) => /* @__PURE__ */ r(S, { extended: e, setExtended: t, children: /* @__PURE__ */ r(f, { logo: i, colors: {
  ...n,
  ...p
}, routes: d, moreText: m, children: o }) });
export {
  l as Sidebar
};
